import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle,
} from '@angular/material/dialog';
import { SharedModule } from '../../shared.module';
import { GeneralConfirmDialogComponent } from './general-confirm-dialog.component';

@NgModule({
  declarations: [GeneralConfirmDialogComponent],
  imports: [
    SharedModule,
    MatDialogModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
  ],
  exports: [GeneralConfirmDialogComponent],
})
export class GeneralConfirmDialogModule {}
